import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import {
  UserService,
} from "@services";
import * as moment from "moment";
import { Subscription } from "rxjs";
@Component({
  selector: "app-bookeds-view",
  templateUrl: "./bookeds-view.component.html",
  styleUrls: ["./bookeds-view.component.scss"],
})
export class BookedsViewComponent implements OnInit, OnDestroy {
  @Input() booking: any;
  @Input() isUser: any;
  @Input() type: string;
  @Input() pnr?: string;
  @Input() isEmployee: boolean;
  @Input() fromTransactions: boolean;
  subscriptions: Subscription[] = [];
  checkDate = false;
  user;
  file: File;
  loading = true;
  totalAdults = 0;
  totalChildren = 0;
  rooms: any[] = [];
  travellersData: any[] = [];
  imageError: boolean[] = [];
  hiddenAirlines = new Set<string>();
  bookings: any[] = [];
  currentIndex = 0;

  constructor(
    public activeModal: NgbActiveModal,
    private userService: UserService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
  if (Array.isArray(this.booking)) {
    this.bookings = this.booking;
  } else {
    this.bookings = [this.booking];
  }
  this.checkPriceDate();
  this.loadTravellersData();
  if (this.bookings[0]?.hotel) {
    this.rooms = this.getHotelRooms(this.bookings[0]);
    this.rooms.forEach((r) => {
      this.totalAdults += r.rates[0].adults;
      this.totalChildren += r.rates[0].children;
    });
  } else if (this.bookings[0]?.rooms) {
    this.rooms = this.bookings[0].rooms;
  }
}

  loadTravellersData() {
    let userUuids: string[] = [];
  
    if (this.bookings?.length) {
      this.bookings.forEach(b => {
        if (Array.isArray(b.userUuid)) {
          userUuids.push(...b.userUuid);
        } else if (typeof b.userUuid === 'string') {
          userUuids.push(b.userUuid);
        }
      });
    } 
    else if (this.booking?.userUuid) {
      if (Array.isArray(this.booking.userUuid)) {
        userUuids.push(...this.booking.userUuid);
      } else {
        userUuids.push(this.booking.userUuid);
      }
    }
  
    const uniqueUuids = [...new Set(userUuids)];
  
    const requests = uniqueUuids.map(uuid =>
      this.userService.getUserByUuid(uuid).toPromise()
    );
  
    Promise.all(requests)
      .then(users => {
        this.travellersData = users;
        this.loading = false;
      })
      .catch(error => {
        this.loading = false;
      });
  }

  onFileChange(event) {
    if (event.target.files.length > 0) {
      this.file = event.target.files[0];
    }
  }
  closeModal() {
      this.activeModal.dismiss("Cross click");
  }

  checkPriceDate() {
    this.checkDate = moment(this.bookings[0].createdAt).isBefore(
      moment(new Date("2022-02-01"))
    );
  }

  createGMapsLink(location: string) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      location
    )}`;
  }

  hasDiscountCardOrFlight() {
    if (this.booking.extraInfo) {
      return this.booking.extraInfo[0]?.discountCard
        ? 1
        : this.booking.extraInfo[0]?.ffCard
        ? 0
        : -1;
    }
    return -1;
  }

  getLogo(value: string) {
    return `assets/img/airlines/small/${value}.png`;
  }

  onImageError(event: Event) {
    const img = event.target as HTMLImageElement;
    const airline = img.getAttribute('data-airline');
    if (airline) {
      this.hiddenAirlines.add(airline);
      img.style.display = 'none';
    }
  }

  getDate(date) {
    return moment(date).format('DD/MM/YYYY HH:mm')
  }

  isValidUrl(value: string): boolean {
    if (!value || value.toLowerCase() === 'airbnb') {
      return false;
    }
    const urlPattern = /^(https?:\/\/)?([\w\-]+\.)+[\w]{2,}(\/\S*)?$/;
    return urlPattern.test(value);
  }

  hasValidScales(booking: any): boolean {
  return booking?.scales?.some(scale => Array.isArray(scale.layovers) && scale.layovers.length > 0);
  }
  
  hasValidCarriers(): boolean {
  return this.booking?.carriers?.some(c => !!c?.trim());
  }

  hasValidAirlines(): boolean {
    return this.booking?.airlines?.some(a => !!a?.trim());
  }

  get activeBooking() {
    return this.bookings[this.currentIndex];
  }

  get currentBooking() {
    return this.bookings[this.currentIndex];
  }

  previous() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  next() {
    if (this.currentIndex < this.bookings.length - 1) {
      this.currentIndex++;
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  transformDate(date) {
    return moment(date).format('DD/MM/YYYY HH:mm')
  }

  getTravellerDisplayName(b: any, root: any): string {
    const pick = (s?: string) => (s ?? '').trim();
    const title = (s: string) =>
      s.replace(/\S+/g, w => w[0].toUpperCase() + w.slice(1).toLowerCase());

    const userName = pick(b?.userName) || pick(Array.isArray(root) ? (root as any).userName : root?.userName);
    if (userName) return title(userName);

    const fromUser = [pick(b?.user?.name), pick(b?.user?.lastname)].filter(Boolean).join(' ').trim();
    if (fromUser) return title(fromUser);

    const fromHolder = [pick(b?.holder?.name), pick(b?.holder?.surname)].filter(Boolean).join(' ').trim();
    return title(fromHolder);
  }

  getBookTypeKey(bt?: string): string {
    return bt ? `my-bookeds.view.${bt.toLowerCase()}` : '';
  }

  getUniqueAncillaries(b: any): string[] {
    const list: string[] = b?.extraInfo?.[0]?.ancillaries ?? [];
    const normalized = list.map(x => (x ?? '').trim()).filter(Boolean);
    return Array.from(new Set(normalized));
  }

  getGroupedFlightAncillaries(extraInfoItem: any): Array<{
    route: string;
    items: Array<{
      shortName: string;
      included?: boolean;
      legType?: string;
    }>;
  }> {
    const ancillaries = Array.isArray(extraInfoItem?.ancillaries)
      ? extraInfoItem.ancillaries
      : [];

    if (!ancillaries.length) {
      return [];
    }

    const normalized = ancillaries
      .map((ancillary: any) => {
        if (typeof ancillary === 'string') {
          return {
            route: '',
            shortName: ancillary,
            included: false,
            legType: '',
          };
        }

        const departure =
          typeof ancillary?.departure === 'string' ? ancillary.departure.trim() : '';
        const arrival =
          typeof ancillary?.arrival === 'string' ? ancillary.arrival.trim() : '';

        return {
          route: departure && arrival ? `${departure} → ${arrival}` : '',
          shortName:
            typeof ancillary?.short_name === 'string' ? ancillary.short_name.trim() : '',
          included: ancillary?.included === true,
          legType:
            typeof ancillary?.legType === 'string' ? ancillary.legType : '',
        };
      })
      .filter((item) => item.shortName);

    const map = new Map<string, Array<{ shortName: string; included?: boolean; legType?: string }>>();

    normalized.forEach((item) => {
      const key = item.route || '__no_route__';

      if (!map.has(key)) {
        map.set(key, []);
      }

      const currentItems = map.get(key)!;

      const exists = currentItems.some(
        (x) =>
          x.shortName === item.shortName &&
          x.included === item.included &&
          x.legType === item.legType
      );

      if (!exists) {
        currentItems.push({
          shortName: item.shortName,
          included: item.included,
          legType: item.legType,
        });
      }
    });

    return Array.from(map.entries()).map(([route, items]) => ({
      route: route === '__no_route__' ? '' : route,
      items,
    }));
  }

  hasGroupedFlightAncillaries(extraInfoItem: any): boolean {
    return this.getGroupedFlightAncillaries(extraInfoItem).length > 0;
  }

  get activeBookingGroupedAncillaries() {
    return this.activeBooking?.extraInfo?.[0]
      ? this.getGroupedFlightAncillaries(this.activeBooking.extraInfo[0])
      : [];
  }

  getHotelRooms(booking: any): any[] {
    if (!booking?.hotel) return [];
    if (Array.isArray(booking.hotel.rooms)) return booking.hotel.rooms;
    if (Array.isArray(booking.hotel.room)) return booking.hotel.room;
    return [];
  }

  getFirstHotelRate(booking: any): any | null {
    const rooms = this.getHotelRooms(booking);
    if (!rooms.length) return null;
    const rates = Array.isArray(rooms[0]?.rates) ? rooms[0].rates : [];
    return rates.length ? rates[0] : null;
  }

  hasFreeCancellationHotel(booking: any): boolean {
    const rate = this.getFirstHotelRate(booking);
    const from = rate?.cancellationPolicies?.[0]?.from;
    if (!from) return false;
    return moment(from).isSameOrAfter(moment());
  }

  getCancellationDetailsHotel(booking: any): string[] {
    const rate = this.getFirstHotelRate(booking);
    const policies = Array.isArray(rate?.cancellationPolicies)
      ? rate.cancellationPolicies
      : [];

    if (!policies.length) {
      return [];
    }

    const beforeText = this.translate.instant('hotel.before');
    const onText = this.translate.instant('hotel.on');
    const beforeCostText = this.translate.instant('hotel.before-cost');

    return policies
      .map((policy: any) => {
        if (policy?.text?.trim()) {
          return policy.text.trim();
        }

        if (policy?.amount && policy?.from) {
          return `${beforeText} ${moment(policy.from).format('HH:mm')} ${onText} ${moment(policy.from).format('DD/MM/YYYY')} ${beforeCostText} ${policy.amount} €`;
        }

        return '';
      })
      .filter(Boolean);
  }

  get hotelCancellationDetails(): string[] {
    return this.getCancellationDetailsHotel(this.activeBooking);
  }

}
